<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro das obrigações</h4>
    </div>
        <ul
      class="process-steps row ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
      role="tablist"
    >
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Dados'}"
        role="tab"
        tabindex="0"
        aria-controls="ptab1"
        aria-labelledby="ui-id-1"
        aria-selected="true"
        aria-expanded="true"
      >
        <a
          @click.prevent="fnEtapa('Dados')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-1"
        >1</a>
        <h5>Dados da obrigações</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Associacoes'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Associacoes')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-2"
        >2</a>
        <h5>Associações</h5>
      </li>
    </ul>
    <div class="card">
      <form style="padding:15px;" class="formreadonly" v-if="etapa =='Dados'" autocomplete="off"> 
        <h4 class="mb-3">Dados</h4>
        <div class="form-row">
          <div class="form-group col-md-6">
             <label for="_form-porte">Porte da empresa</label>
             <select class="form-control" id="_form-porte" required v-model="cadastro.porteId">
                <option value="" selected disabled></option>
                  <option :key="i" v-for="(item,i) in portes" :value="item.porteId" >{{item.titulo}}</option>
              </select>
          </div>
          <div class="form-group col-md-6">
             <label for="_form-regimeTributario">Regime tributário</label>
             <select class="form-control" id="_form-regimeTributario" required v-model="cadastro.regimeId">
                 <option value="" selected disabled></option>
                  <option :key="i" v-for="(item,i) in regimestributarios" :value="item.regimeId" >{{item.titulo}}</option>
              </select>
          </div>
          <div class="form-group col-md-6">
            <label for="_form-aliquota">Aliquota se simples nacional percentual</label>
              <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.aliquota"
              id="_form-aliquota"
              required
            />
              
          </div>
          <div class="form-group col-md-2">
            <label for="_form-cnae">CNAE</label>
              <input
              type="text"
              class="form-control"
              v-model="cadastro.cnae"
              id="_form-cnae"
              required
              
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-iptuOficina">IPTU da sede da oficina</label>
              <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.iptuSedeOficina"
              id="_form-iptuOficina"
              required
              v-bind:precision="2"
              currency="R$"
              separator="."

            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-iptuEstacionamento">IPTU do estacionamento se tiver</label>
              <vue-numeric
              currency="R$"
              type="text"
              class="form-control"
              v-model="cadastro.iptuEstacionamento"
              id="_form-iptuEstacionamento"
              required
              v-bind:precision="2"
              separator="."
            />
          </div>
          <div class="form-group col-sm-6">
              <label for="_form-patronal">Sindicato patronal</label>
              <input type="text" class="form-control" required v-model="cadastro.sindicatoPatronal" maxlength="99"/>
          </div>
          <div class="form-group col-md-3">
             <label for="_form-regimeTributario">Período</label>
             <select class="form-control" id="_form-regimeTributario" required v-model="cadastro.sindicatoPeriodo">
                 <option value="" selected disabled></option>
                  <option :key="i" v-for="(item,i) in periodos" :value="item.periodoId" >{{item.titulo}}</option>
              </select>
          </div>
          <div class="form-group col-md-3">
            <label for="_form-sindicatoCusto">Sindicato Custo</label>
              <vue-numeric
              currency="R$"
              type="text"
              class="form-control"
              v-model="cadastro.sindicatoPatronalCusto"
              id="_form-sindicatoCusto"
              required
              v-bind:precision="2"
              separator="."
            />
          </div>
          
          <div class="form-group col-sm-12">
              <label for="_form-descricao">Sindicato descrição</label>
              <textarea class="form-control" required v-model="cadastro.sindicatoPatronalDescricao" maxlength="99">
              </textarea>
          </div>
        </div>
      </form>
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Associacoes'" >
        <div class="" v-show="associacoes">
              <vs-table
                :data="associacoes">
                <template slot="header" >
                  <h3>
                    Associações cadastrados
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th>
                    Associação
                  </vs-th>
                  <vs-th style="width:150px;">
                    Custo
                  </vs-th>
                  <vs-th style="width:150px;">
                    Período
                  </vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                  
                    <vs-td :data="tr.associacaoDescricao">
                      {{tr.associacaoDescricao}}  {{tr.etapaAId}}
                    </vs-td>
                    <vs-td :data="tr.associacaoCusto">
                      {{tr.associacaoCusto}}
                    </vs-td>
                    <vs-td :data="tr.socioParticipacao">
                      {{fnConcat(tr.associacaoPeriodo)}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
        </div>
      </form>      
    </div>
  </div>
</template>

<script>
import { getSuccess, clientKey } from "../../../../global/utils";

export default {
  data() {
    return {
      cadastro: {},
      portes:{},
      regimestributarios:{},
      periodos:{},
      associacoes:[],
      associacao:{
          etapaId:null
      },
      cadastroId: null,
      contrato:{},
      etapa: 'Dados'
    }
  },
  mounted() {
    this.fnGetPorte()
    this.fnGetRegimes()
    this.fnGetPeriodos()
    this.fnGetContratacao()
  },
  methods: {

     async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_02`)
        .then((res) => {
          this.cadastro.ContratacaoId = res.data.contratacaoId;
          this.cadastroId = res.data.contratacaoId
          if(res.data.contratacoesEVO02 != null){
            this.cadastro = res.data.contratacoesEVO02
          }
          if(res.data.contratacoesEVO02.contratacoesEVO02A != null){
            this.associacoes = res.data.contratacoesEVO02.contratacoesEVO02A
          }
          console.log(this.cadastro.splice(this.cadastro.contratacoesEVO02A))
        })
        .catch(() => {});
    },
   
     async fnGetPorte(){
        await this.$http.get('listaportesempresas/api')
        .then(res=> {
          this.portes = res.data
        })
        .catch(()=>{})
     },
     async fnGetRegimes(){
        await this.$http.get('listaregimestributarios/api')
        .then(res=> {
          this.regimestributarios = res.data
        })
        .catch(()=>{})
     },
     async fnGetPeriodos(){
        await this.$http.get('listaperiodos/api')
        .then(res=> {
          this.periodos = res.data
        })
        .catch(()=>{})
     },
    async fnCadastra(e) {
      e.preventDefault();
      console.log(this.cadastro.etapaId )
      const metodo = this.cadastro.etapaId ? "put" : "post";
      this.cadastro.tsAlteracao = this.cadastro.etapaId
        ? this.$moment().format()
        : null;
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "/";
      await this.$http[metodo]("/etapa_02" + completaUrl, this.cadastro)
        .then((res) => {
          if ( metodo == "post"){this.cadastro = res.data} 
          getSuccess();
        })
        .catch(() => {});
    },    
    fnEtapa(val) {
      if (this.cadastro.etapaId == undefined) {
        if (val == "Associacoes") {
          this.$toasted.global.defaultInfo({
            msg: "Finalize os dados das obrigações.",
          });
        }
      } else {
        this.etapa = val;
      }
    },
    async fncadastraAssociacao(e) {
      e.preventDefault();
      const metodo = this.associacao.etapaAId ? "put" : "post";
      this.associacao.tsAlteracao = this.associacao.etapaAId
        ? this.$moment().format()
        : null;
      const completaUrl = this.associacao.etapaAId ? "/" + this.associacao.etapaAId : "/" + this.cadastroId;
      this.associacao.etapaId = this.cadastro.etapaId
      await this.$http[metodo]("/etapa_02A" + completaUrl, this.associacao)
        .then((res) => {
          if ( metodo == "post"){this.associacoes.push(res.data)} 
          this.associacao = {
              associacaoDescricao: '',
              associacaoCusto: '',
              associacaoPeriodo: '',
              etapaId: this.cadastro.etapaId
          }
          getSuccess();
        })
        .catch(() => {});
    },
    fnEditar(i){
        this.associacao = this.associacoes[i]
    },
    fnConcat(val){
     var item = this.periodos.filter((periodos) => {
        return periodos.periodoId ==val
      });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
        convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_02A/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.associacoes.map(item => item.etapaAId).indexOf(val) 
          this.associacoes.splice(i, 1)
          getSuccess();
        })
        .catch(() => {});
    }

  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}

</style>